import { AppBar, IconButton, Toolbar } from '@material-ui/core';
import { PagePart } from 'app/modules/step-engine/utils/step-engine-constants';
import { IRootState } from 'app/shared/reducers';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ISpbNavbarItem } from 'spb-react-components';
import SideBar from '../sidebar/sidebar';
import './header.scss';

type IHeader = {
  didomiObject: any;
  footerLinks: any;
  sideBarContent: any;
  selectItem?: (value: ISpbNavbarItem) => void;
}

const Header = (props: IHeader) => {
  const { didomiObject, footerLinks, sideBarContent, selectItem } = props;
  const { isAuthenticated } = useSelector((state: IRootState) => state.kubrickManagement);
  const [menuOpen, setMenuOpen] = useState(false);
  const cmsContent = useSelector((state: IRootState) => state.cms.cmsContent);
  const { smallTopIcon } = cmsContent[PagePart.GENERIC_SIDE_NAV_PDV]?.prismic || {}
  const { bankProduct } = useSelector((state: IRootState) => state.appManagement?.frontConfig);

  const toggleMenu = () => {
    const menuButton = document.getElementById('menu-button');
    if (menuOpen) {
      menuButton.classList.remove('menu-active');
    } else {
      menuButton.classList.add('menu-active');
    }
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <AppBar id="header" position="static">
        <SideBar didomiObject={didomiObject} menuOpen={menuOpen} setMenuClose={toggleMenu} footerLinks={footerLinks} sideBarContent={sideBarContent} selectItem={selectItem} />
        <Toolbar>
          {(isAuthenticated || bankProduct) &&
            <IconButton onClick={toggleMenu} id="menu-button" className="menu-button" >
              <span className="burger-menu"></span>
              <span className="burger-menu"></span>
              <span className="burger-menu"></span>
            </IconButton>
          }
          <img className="app-logo" src={smallTopIcon} />
        </Toolbar>
      </AppBar>
    </>
  );
};


export default Header;